<template>
    <v-container v-resize="onResize">
        <v-layout v-if="!this.loading" row wrap align-center>
            <v-flex xs12 lg4>
                <h1>Ministerial Statements</h1>
            </v-flex>
            <v-flex class="pt-xs-2" xs6 sm3 offset-md6 md2>
                <count-up :endVal="items.length" text="Ministerial statements since federation" />
            </v-flex>
        </v-layout>

        <br/>

        <v-layout v-if="!this.loading" row wrap align-center class="hidden-print-only">
            <v-flex xs12 md2 mt-4 mt-xs-2>
                <div>
                    <v-text-field :class="{mobileTextField: isMobile}" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    <v-menu v-if="!this.loading && this.isMobile" d-inline offset-y :nudge-left="140" :close-on-content-click="true">
                        <v-btn outline small slot="activator">
                            Sort <v-icon>sort</v-icon>
                        </v-btn>
                        <v-list>
                             <v-subheader
                                >
                                Sort by:
                                </v-subheader>
                            <v-list-tile v-for="(item, index) in HEADERS" :key="item.value" @click="changeSort(item.value)">
                                <v-list-tile-title>
                                    {{ item.text }}
                                    <v-icon v-if="PAGINATION.sortBy === item.value">{{PAGINATION.descending ? 'arrow_downward':'arrow_upward'}}</v-icon>
                                </v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu>
                </div>
            </v-flex>
            <v-flex xs12 md2 mt-4 mt-xs-2>
                <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                        label="Filter by minister"
                        v-model="ministersSelected"
                        :items="ministers"
                        item-text="displayName"
                        item-value="displayName"
                        auto-select-first
                        clearable
                        multiple
                        small-chips
                        deletable-chips                    
                    >
                    <template v-slot:selection="{ item, index }">
                        <v-chip @input="deleteMinistersSelected(item.displayName)" small close v-if="index == 0">{{item.surname}}</v-chip>
                        <v-chip small v-if="index == 1">+ {{ministersSelected.length - 1}} more</v-chip>
                    </template>
                    </v-autocomplete>
                </v-card-title>
            </v-flex>
            <v-flex xs12 md2 mt-4 mt-xs-2>
                <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                        label="Filter by portfolio"
                        v-model="portfoliosSelected"
                        :items="portfolios"
                        item-text="Filter"
                        item-value="Filter"
                        auto-select-first
                        clearable
                        multiple
                        small-chips
                        deletable-chips                    
                    >
                    <template v-slot:selection="{ item, index }">
                        <v-chip @input="deletePortfoliosSelected(item)" small close v-if="index == 0">{{item | truncate(0, 25, true)}}</v-chip>
                        <v-chip small v-if="index == 1">+ {{portfoliosSelected.length - 1}} more</v-chip>
                    </template>
                    </v-autocomplete>
                </v-card-title>
            </v-flex>

            <v-flex xs12 md2 mt-4 mt-xs-2>
                <v-card-title class="pb-0 mb-0">
                    <v-autocomplete
                        label="Filter by tags"
                        v-model="tagsSelected"
                        :items="tags"
                        item-text="Tags"
                        item-value="Tags"
                        auto-select-first
                        clearable
                        multiple
                        small-chips
                        deletable-chips                    
                    >
                    <template v-slot:selection="{ item, index }">
                        <v-chip @input="deleteTagsSelected(item)" small close v-if="index == 0">{{item | truncate(0, 25, true)}}</v-chip>
                        <v-chip small v-if="index == 1">+ {{tagsSelected.length - 1}} more</v-chip>
                    </template>
                    </v-autocomplete>
                </v-card-title>
            </v-flex>

            <v-flex xs12 md2 mt-4 mt-xs-2>
                <v-card-title class="pb-0 mb-0">
                <v-autocomplete
                    label="Select a Parliament"
                    v-model="SELECTED_PARLIAMENTS"
                    :items="this.$store.getters.GET_PARLIAMENTS_ORDERED"
                    :item-text="getParliamentLabel"
                    item-value="PID"
                    :filter="FILTER_PARLIAMENT_OPTIONS"
                    auto-select-first
                    multiple
                    small-chips
                    clearable
                    deletable-chips>
                    <template v-slot:selection="{ item, index }">
                        <v-chip @input="deleteParliamentSelectionItem(item.Name)" small close v-if="index == 0">{{item.Name}}</v-chip>
                        <v-chip small v-if="index == 1">+ {{SELECTED_PARLIAMENTS.length - 1}} more</v-chip>
                    </template>
                    <template
                    v-slot:prepend-item
                    v-if="this.$store.getters.GET_PARLIAMENTS.length > 0">
                    <v-list-tile
                        v-on:click="CLICK_CURRENTPARLIAMENT"
                        :value="currentParliamentValue"
                        ripple>
                        <v-list-tile-action>
                        <v-icon>{{ currentParliamentIcon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                        <v-list-tile-title
                            >Current Parliament</v-list-tile-title
                        >
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider></v-divider>
                    </template>
                </v-autocomplete>
                </v-card-title>
            </v-flex>

            <v-flex xs12 md1 mt-4 mt-xs-2>
                <v-card-title class="pb-0 mb-0">
                    <v-menu
                        ref="menuFrom"
                        v-model="menuFrom"
                        :close-on-content-click="false"                                                
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="dateFrom"
                            label="Date from"                                                       
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="dateFrom" no-title scrollable>
                        </v-date-picker>
                    </v-menu>
                </v-card-title>
            </v-flex>

            <v-flex xs12 md1 mt-4 mt-xs-2>
                <v-card-title class="pb-0 mb-0">
                    <v-menu
                        ref="menuTo"
                        v-model="menuTo"
                        :close-on-content-click="false"                                                
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                    >
                        <template v-slot:activator="{ on }">
                        <v-text-field
                            v-model="dateTo"
                            label="Date to"                                                        
                            v-on="on"
                        ></v-text-field>
                        </template>
                        <v-date-picker v-model="dateTo" no-title scrollable>
                        </v-date-picker>
                    </v-menu>
                </v-card-title>
            </v-flex>
        </v-layout>
        <br/>

        <loader v-if="loading" />       

        <div class="referendums-table"> 
            <v-data-table 
                v-if="!loading"
                :headers="HEADERS"
                :footer-props="FOOTERS"
                :items="itemsFiltered"
                item-key="$id"
                :search="search"
                :rows-per-page-items="ROWS_LISTITEMS"
                :pagination.sync="PAGINATION"
                :hide-headers="isMobile || isPrint"
                :expand="expand"
                :hide-actions="isPrint"
                :disable-initial-sort="true"
                :class="{ mobileDataTable: isMobile || isPrint, 'elevation-1': true }">
                <template v-slot:items="props">
                    <tr v-if="isMobile || isPrint">
                        <td>
                            <div class="flex-content">
                                <div class="flex-item"><h3 class="pb-xs-0"><a target="_blank" :href="props.item.Link">{{ props.item.Title }}</a></h3></div>
                                <div class="flex-item" data-label="Date">{{ props.item.Date | stringDateFormat }}</div>
                                <div class="flex-item" data-label="Minister"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Minister.Phid } }">{{ props.item.Minister.DisplayName }}</router-link></div>
                                <div class="flex-item" data-label="Portfolio">
                                    <div v-for="(portfolio, index) in props.item.Portfolios" :key="index">{{ portfolio }}</div>
                                </div>
                                <div class="flex-item" data-label="Tags">
                                    <div v-for="(tag, index) in props.item.Tags" :key="index">{{ tag }}</div>
                                </div>                                
                            </div>
                        </td>
                    </tr>
                    <tr v-else>
                        <td class="text-xs-left">{{ props.item.Date | stringDateFormat }}</td>
                        <td class="text-xs-left font-weight-bold"><a target="_blank" :href="props.item.Link">{{ props.item.Title }}</a></td>
                        <td class="text-xs-left"><router-link :to="{ name: $store.state.ROUTE_PARLIAMENTARIAN, params: { PHID: props.item.Minister.Phid } }">{{ props.item.Minister.DisplayName }}</router-link></td>                        
                        <td class="text-xs-left">
                            <div v-for="(portfolio, index) in props.item.Portfolios" :key="index">{{ portfolio }}</div>
                        </td>
                        <td class="text-xs-left">
                            <div v-for="(tag, index) in props.item.Tags" :key="index">{{ tag }}</div>
                        </td>
                    </tr>
                </template>
            </v-data-table>    
        </div>   
        <br/>
        <v-layout row wrap class="hidden-print-only">
            <v-flex xs12>
                <v-btn class="csvButton" @click="exportCsv" v-on:keyup.enter="exportCsv" color="primary">
                    <v-icon aria-hidden="true" :class="csvDownloadClass">{{csvDownloadIcon}}</v-icon>
                    <span>&nbsp;Download CSV</span>
                </v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>    
    import print from '../../mixins/print';
    import Loader from '@/components/Loader.vue';
    import axios from 'axios';
    import CountUp from "../StatisticalInformation/CountUp.vue";
    window.Handbook = window.Handbook || {}
    const apiUri = window.Handbook.ApiUri || "https://localhandbookapi.aph.gov.au/";
    axios.defaults.baseURL = apiUri;

    export default {
        created() {
            this.initialiseItems();
            this.onResize();
        },
        mixins: [print],
        components: {
            Loader,
            CountUp
        },
        data() {
            return {
                expand: false,
                isMobile: false,
                search: '',
                items: [],
                loading: true,
                csvDownloading: false,
                chartType: 'perYear',
                ministersSelected: [],
                portfoliosSelected: [],
                tagsSelected: [],
                SELECTED_PARLIAMENTS: [],
                dateFrom: null,
                dateTo: null,
                menuFrom: false,
                menuTo: false,
                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],
                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE,
                    sortBy: 'Date',
                    descending: true
                },
                HEADERS: [
                {
                    text: 'Date',
                    value: 'Date',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Title',
                    value: 'Title',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Minister',
                    value: 'Minister.DisplayName',
                    align: 'left',
                    sortable: true,
                },
                {
                    text: 'Portfolio',
                    value: 'Portfolios',
                    align: 'left'                    
                },
                {
                    text: 'Tags',
                    value: 'Tags',
                    align: 'left'                    
                },                
                ],
                FOOTERS: {
                    showFirstLastPage: true,
                    firstIcon: 'mdi-arrow-collapse-left',
                    lastIcon: 'mdi-arrow-collapse-right',
                    prevIcon: 'mdi-minus',
                    nextIcon: 'mdi-plus',
                },
            }
        },
        watch: {
            SELECTED_PARLIAMENTS: function(newValue) {
                if (newValue.length > 0) {
                    this.dateFrom = null;
                    this.dateTo = null;                    
                }
            },
            dateFrom: function(newValue) {
                if (newValue) {
                    this.SELECTED_PARLIAMENTS = [];                    
                }                
            },
            dateTo: function(newValue) {
                if (newValue) {
                    this.SELECTED_PARLIAMENTS = [];
                }                
            },            
        },
        computed: {
            csvDownloadIcon(){
                return this.csvDownloading ? 'cached' : 'text_snippet';
            },
            csvDownloadClass(){
                let csvClass = 'mr-1';
                if (this.csvDownloading){
                    csvClass = csvClass + ' loading'
                }
                return csvClass;
            },
            currentParliamentIcon: function () {
            let parlArray = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                let currentParliament = parlArray[0].PID;
                if (this.SELECTED_PARLIAMENTS.indexOf(currentParliament) > -1) {
                    return '$vuetify.icons.checkboxOn';
                } else {
                    return '$vuetify.icons.checkboxOff';
                }
            },
            currentParliamentValue: function () {
            let parlArray = this.$store.getters.GET_PARLIAMENTS;
            if (
                this.SELECTED_PARLIAMENTS.includes(parlArray[parlArray.length - 1].PID)
            ) {
                return parlArray[parlArray.length - 1].PID;
            } else {
                return false;
            }
            },
            itemsFiltered() {
                let tempItems = [...this.items];

                if (this.ministersSelected.length > 0) {
                    tempItems = tempItems.filter(i => this.ministersSelected.includes(i.Minister.DisplayName))
                }

                if (this.portfoliosSelected.length > 0) {                    
                    tempItems = tempItems.filter(i => i.Portfolios.filter(p => this.portfoliosSelected.includes(p)).length > 0 );
                }

                if (this.tagsSelected.length > 0) {                    
                    tempItems = tempItems.filter(i => i.Tags.filter(t => this.tagsSelected.includes(t)).length > 0 );
                }

                // Create date ranges based on selected parliaments
                let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                const dateRanges = this.SELECTED_PARLIAMENTS.map(pid => {
                const parliament = parliaments.find(p => p.PID === pid);
                if (!parliament) return null;
                
                const startDate = parliament.DateOpening || parliament.DateElection;
                const endDate = parliament.DateDissolution || new Date().toISOString().split('T')[0]; // Current date if dissolution date is null

                return { startDate, endDate };
                }).filter(range => range !== null);

                // Function to check if a date falls within any date range
                const isInDateRange = (date, ranges) => {
                for (let range of ranges) {
                    if (new Date(date) >= new Date(range.startDate) && new Date(date) <= new Date(range.endDate)) {
                    return true;
                    }
                }
                return false;
                };

                if (dateRanges.length > 0) {
                    tempItems = tempItems.filter(statement => isInDateRange(statement.Date, dateRanges));
                }         

                if(this.dateFrom) {
                    tempItems = tempItems.filter(statement => new Date(statement.Date) >= new Date(this.dateFrom));
                }

                if (this.dateTo) {
                    tempItems = tempItems.filter(statement => new Date(statement.Date) <= new Date(this.dateTo));
                }

                return tempItems;
            },
            ministers() {
                return [...new Set(this
                    .items
                    .filter( i => i.Minister)
                    .map(i => ({
                        displayName: i.Minister.DisplayName,
                        surname: i.Minister.DisplayName.split(',')[0].trim()
                    }))
                    )]
                    .sort((a, b) => a.displayName.localeCompare(b.displayName));
            },
            portfolios() {
                return [...new Set(this.items.flatMap(i => i.Portfolios))].sort();
            },
            tags() {
                return [...new Set(this.items.flatMap(i => i.Tags))].sort();
            },
        },
        mounted() {
            this.onResize();
            //Set page to 10 on mobile, only on mount
            if (this.isMobile){
                this.PAGINATION.rowsPerPage = 10;
            }
        },
        methods: {
            FILTER_PARLIAMENT_OPTIONS: function (item, queryText) {
                const pId = item.PID;
                const name = item.Name.toLowerCase();
                const searchText = queryText.toLowerCase();
                return (
                    name.indexOf(searchText) > -1 || pId.toString().indexOf(searchText) > -1
                );
                },
            CLICK_CURRENTPARLIAMENT: function () {
                this.$nextTick(() => {
                    let parliaments = this.$store.getters.GET_PARLIAMENTS_ORDERED;
                                let currentParliament = parliaments[0].PID;
                                if (this.SELECTED_PARLIAMENTS.includes(currentParliament)) {
                                    let index = this.SELECTED_PARLIAMENTS.indexOf(currentParliament);
                                    if (index > -1) {
                                        this.SELECTED_PARLIAMENTS.splice(index, 1);
                                    }
                                } else {
                                    this.SELECTED_PARLIAMENTS.push(currentParliament);
                                }                    
                });
            },
            onResize() {
                if (window.innerWidth < 1060) {
                    this.isMobile = true;
                }
                else {
                    this.isMobile = false;
                }
            },
            changeSort(column) {
                if (this.PAGINATION.sortBy === column) {
                    this.PAGINATION.descending = !this.PAGINATION.descending
                } 
                else {
                    this.PAGINATION.sortBy = column
                    this.PAGINATION.descending = false
                }
            },
            deleteMinistersSelected(item) {
                this.ministersSelected = this.ministersSelected.filter(i => i !== item);
            },
            deletePortfoliosSelected(item) {
                this.portfoliosSelected = this.portfoliosSelected.filter(i => i !== item);
            },            
            deleteTagsSelected(item) {
                this.tagsSelected = this.tagsSelected.filter(i => i !== item);
            },                        
            deleteParliamentSelectionItem(item) {
                this.SELECTED_PARLIAMENTS = this.SELECTED_PARLIAMENTS.filter(find => find.Name !== item.Name);                
            },
            getParliamentLabel(parliament) {                
                const startDate = parliament.DateOpening || parliament.DateElection;
                const endDate = parliament.DateDissolution || 'present';
                return `${parliament.Name} (${startDate} to ${endDate})`;
            },
            initialiseItems() {
                this.loading = true;
                const url = 'MinisterialStatements/MinisterialStatements';
                axios.get(`api/${url}`)
                    .then(response => {
                        this.items = response.data;
                        this.loading = false;
                    });
            },
            exportCsv() {
                this.$gtag.event('ministerial statements download csv', {
                    'event_category': 'downloads',
                    'event_label': `ministerial statements csv download`,
                    'value': 1
                });

                this.csvDownloading = true;
                const records = this.items.map(i => 
                    ({ 
                        Date: i.Date,
                        Title: i.Title,
                        Minister: i.Minister.DisplayName,
                        Portfolio: i.Portfolios.join(', '),
                        Tags: i.Tags.join(', '),
                        Link: i.Link
                    }));
                let headers = this.HEADERS.map(h => h.text);
                const filename = 'Ministerial statements';
                const comment = `Data current as of ${(new Date()).toLocaleDateString()}`;
                this.$store.dispatch('GETCSV', { DATA: records, HEADERS: headers, FILENAME: filename, COMMENT: comment })
                    .catch(this.showError)
                    .finally(() => this.csvDownloading = false);
            }
        },
    }
</script>
<style lang="stylus" scoped>
    .v-progress-circular {
        margin: 1rem
    }

    .v-datatable .tr {
        display:table-row;
    }

    .v-datatable a.tr {
        color: #0e1531de;
        text-decoration:none;
        border: 1px solid #dbdbdb;
        border-left: none;
        border-right: none;
    }

    .v-datatable tbody td {
        vertical-align: middle;
    }
    
    @media screen and (max-width: 1420px) {
        .referendums-table >>> table.v-table thead td:not(:nth-child(1)), 
        .referendums-table >>> table.v-table tbody td:not(:nth-child(1)), 
        .referendums-table >>> table.v-table thead th:not(:nth-child(1)), 
        .referendums-table >>> table.v-table tbody th:not(:nth-child(1)), 
        .referendums-table >>> table.v-table thead td:first-child, 
        .referendums-table >>> table.v-table tbody td:first-child, 
        .referendums-table >>> table.v-table thead th:first-child, 
        .referendums-table >>> table.v-table tbody th:first-child,
        .referendums-table >>> table.v-table thead th:first-child {
            padding: 0 14px !important;
        }

        .referendums-table >>> th {
            white-space: break-spaces;
        }
    }
</style>